/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Step_Event_GroupInputs */

const en_new_project_step_event_group = /** @type {(inputs: New_Project_Step_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settings`)
};

const fr_new_project_step_event_group = /** @type {(inputs: New_Project_Step_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paramètres`)
};

const de_new_project_step_event_group = /** @type {(inputs: New_Project_Step_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einstellungen`)
};

const it_new_project_step_event_group = /** @type {(inputs: New_Project_Step_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impostazioni`)
};

const ru_new_project_step_event_group = /** @type {(inputs: New_Project_Step_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройки`)
};

const es_new_project_step_event_group = /** @type {(inputs: New_Project_Step_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustes`)
};

const zh_cn2_new_project_step_event_group = /** @type {(inputs: New_Project_Step_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`设置`)
};

const ja_new_project_step_event_group = /** @type {(inputs: New_Project_Step_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`設定`)
};

const hi_new_project_step_event_group = /** @type {(inputs: New_Project_Step_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सेटिंग्स`)
};

const pt_pt2_new_project_step_event_group = /** @type {(inputs: New_Project_Step_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurações`)
};

/**
* | output |
* | --- |
* | "Settings" |
*
* @param {New_Project_Step_Event_GroupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_step_event_group = /** @type {((inputs?: New_Project_Step_Event_GroupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Step_Event_GroupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_step_event_group(inputs)
	if (locale === "de") return de_new_project_step_event_group(inputs)
	if (locale === "it") return it_new_project_step_event_group(inputs)
	if (locale === "ru") return ru_new_project_step_event_group(inputs)
	if (locale === "es") return es_new_project_step_event_group(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_step_event_group(inputs)
	if (locale === "ja") return ja_new_project_step_event_group(inputs)
	if (locale === "hi") return hi_new_project_step_event_group(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_step_event_group(inputs)
	return en_new_project_step_event_group(inputs)
});